// 接口地址
export const websocketUrl = (store) => {
  return `${process.env.VUE_APP_WEBSOCKET_URL}?token=${store.state.user.token}&projectId=${store.state.cadModules.rlProject_id}`;
};

export const baseURL = process.env.VUE_APP_BASE_URL;

//检测项目地址
export const detectionUrl = process.env.VUE_APP_DETECTION_URL;
